import { UsuarioCadastrosRequest } from 'api/Assessor/usuario';
import LayoutContext from 'components/Layout/LayoutContext';
import Loading from 'components/Modal/__LEGACY__/AbrirVotacaoPautaModal/Loading';
import PageTitle from 'components/__SHARED__/PageTitle/PageTitle';
import PrivateContainer from 'components/__SHARED__/PrivateContainer';
import { ITopBarMenuItem } from 'components/__SHARED__/TopBar/TopBarMenuItem';
import ErrorHandler from 'helpers/utils/ErrorHandler';
import translation from 'locales/translation';
import moment from 'moment';
import UnauthorizedScreen from 'pages/Errors/UnauthorizedScreen/UnauthorizedScreen';
import { useCallback, useContext, useEffect, useMemo, useReducer } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { assessorActionRelatorioCadastros } from 'store/modules/assessor/actions';
import { IAuthReducer } from 'store/modules/AuthReducer';
import { IReducer } from 'store/Reducer';
import Filtros from './Filtros';
import { cadastroInitialState, cadastroReducer } from './reducer';
import useStyle from './style';
import Table from './Table';

export default function ListagemCadastros() {
  const classes = useStyle();
  const dispatch = useDispatch();
  const { usuario } = useSelector<IReducer, IAuthReducer>(
    (state) => state.auth
  );
  const { gerandoRelatorio } = useSelector((state: IReducer) => state.assessor);
  const { setPageMenuItems } = useContext(LayoutContext);
  const [{ filters, hasDateError }, action] = useReducer(
    cadastroReducer,
    cadastroInitialState
  );
  const { currentEvent } = useSelector((state: IReducer) => state.assembleias);
  const setFilters = (payload: Partial<UsuarioCadastrosRequest> | undefined) =>
    action({ name: 'setFilters', payload });
  const setDateErrorFlag = (payload: boolean) =>
    action({ name: 'setDateErrorFlag', payload });

  const downloadRelatorio = useCallback(() => {
    if (!filters) return;
    const inicio = moment(filters.dataInicioCadastro!).format('YYYY-MM-DD');
    const fim = moment(filters.dataFimCadastro!).format('YYYY-MM-DD');
    const fileName = `Cadastros__coop-${filters.coop!}__${inicio}__${fim}.xlsx`;
    dispatch(assessorActionRelatorioCadastros(filters, fileName, ErrorHandler));
  }, [dispatch, filters]);

  const menuItens = useMemo<ITopBarMenuItem[]>(() => {
    if (
      (usuario?.perfil.id === 'pertencer_consulta' &&
        !usuario?.perfil.assessorRoute.cadastros.ver &&
        currentEvent?.tipo !== 'REU') ||
      (usuario?.perfil.id !== 'pertencer_consulta' &&
        !usuario?.perfil.assessorRoute.cadastros.ver)
    )
      return [];
    const relatorio: ITopBarMenuItem = {
      label: translation.ListaLogins.relatorioMenuLabel,
      disabled: !filters || gerandoRelatorio,
      onClick: downloadRelatorio,
    };
    return [relatorio];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuario, filters, downloadRelatorio, gerandoRelatorio]);

  useEffect(() => {
    setPageMenuItems(menuItens);
    return () => setPageMenuItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuItens]);

  if (
    (usuario?.perfil.id === 'pertencer_consulta' &&
      !usuario?.perfil.assessorRoute.cadastros.ver &&
      currentEvent?.tipo !== 'REU') ||
    (usuario?.perfil.id !== 'pertencer_consulta' &&
      !usuario?.perfil.assessorRoute.cadastros.ver)
  ) {
    return <UnauthorizedScreen />;
  }

  return (
    <PrivateContainer
      header={<PageTitle title={translation.ListaLogins.title} />}
      headerClassName={classes.header}
    >
      <Filtros onChangeFilter={setFilters} onValidateDate={setDateErrorFlag} />
      <Table filters={filters} hasDateError={hasDateError} />
      {gerandoRelatorio && <Loading text='Gerando relatório' />}
    </PrivateContainer>
  );
}
